import config from '../config';
export default (function () {
    return window.location.replace(config[process.env.API_ENV].accountsUrl + "/login?redirect=" + window.location);
});
//# sourceMappingURL=loginRedirect.js.map